/* eslint-disable consistent-return */
import { TOO_MANY_DOCUMENTS, CONTENT_OR_DOC_REQUIRED } from './messages';
import {
  CANDIDATE_STORY_MAX_CHARACTER_LIMIT,
  MAX_DOCUMENTS,
} from '../../constants';

const MIN_CHARACTER_LIMIT = 3;

const contentOrDocRequired = (value, allValues, props, name) => {
  const key = name.split('.')[2];
  if (
    (!props.candidateStories[key] ||
      !props.candidateStories[key].documents ||
      props.candidateStories[key].documents.length < 1) &&
    (!value || value.length < MIN_CHARACTER_LIMIT)
  ) {
    return CONTENT_OR_DOC_REQUIRED;
  }
};

const getTotalDocumentCount = candidateStories => {
  if (!candidateStories) return 0;

  let totalCount = 0;

  if (candidateStories.promptGroup) {
    Object.keys(candidateStories.promptGroup).forEach(recordKey => {
      if (typeof candidateStories.promptGroup[recordKey] === 'object') {
        Object.keys(candidateStories.promptGroup[recordKey]).forEach(
          promptId => {
            const documents =
              candidateStories.promptGroup[recordKey][promptId]?.documents ||
              [];
            totalCount += documents.length;
          },
        );
      }
    });
  }

  // TODO: [EADJU-1882] Clean up legacy cans content
  Object.keys(candidateStories).forEach(key => {
    if (key !== 'content' && key !== 'promptGroup') {
      const documents = candidateStories[key]?.documents || [];
      totalCount += documents.length;
    }
  });

  return totalCount;
};

const maxDocuments = (value, allValues, props, name) => {
  const key = name.split('.')[2];
  if (
    !props.candidateStories[key] ||
    !props.candidateStories[key].documents ||
    props.candidateStories[key].documents.length > MAX_DOCUMENTS
  ) {
    return { message: TOO_MANY_DOCUMENTS, maxDocuments: MAX_DOCUMENTS };
  }
};

const validateMaxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;

const validateMinLength = value => {
  if (!value || value.trim().length < MIN_CHARACTER_LIMIT) {
    return `Must be at least ${MIN_CHARACTER_LIMIT} characters`;
  }
  return undefined;
};

const maxContentLength = validateMaxLength(CANDIDATE_STORY_MAX_CHARACTER_LIMIT);

export {
  contentOrDocRequired,
  maxDocuments,
  getTotalDocumentCount,
  maxContentLength,
  validateMinLength,
  validateMaxLength,
};
